import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert';
import TheHeader from "../comm/inCar/TheHeader";
import ApiHelper from "src/utils/api/api_helper";
import { CButton, CContainer, CCol, CRow, CCardBody, CCardHeader, CCardFooter, CFormGroup } from "@coreui/react";
import { useHistory } from "react-router-dom";
import { setCorp, setTask } from "src/modules/main";
import { persistor } from "src/store";
import Error from "src/views/custRequest/comm/Error";


var Agent = navigator.userAgent.toLowerCase();
// 카카오인앱 브라우저 접속 유무 판단
if(Agent.includes("kakao")){
  // 카카오인앱 브라우저 닫기
  window.location.href = "kakaotalk://inappbrowser/close";
  // 크롬으로 열기
  window.location.href = 'intent://'+window.location.href.replace(/https?:\/\//i,'')+'#Intent;scheme=http;package=com.android.chrome;end';  
}

const MainPage = () => {
  const state = useSelector((state) => state.main);
  const dispatch = useDispatch();
  const history = useHistory();
  const [tasks, setTasks] = React.useState([]);
  const ifKey = useLocation().pathname.substring(1);
  const param = { ifKey };
  const param2 = { corpNo: state.corpNo };
  const [isLoading, setIsLoading] = React.useState(true);
  const [showPopup, setShowPopup] = React.useState(false);
  const [showPopup2, setShowPopup2] = React.useState(false);
  const [taskNo, setTaskNo] = React.useState('');
  const [lifeQualificationYn, setLifeQualificationYn] = React.useState('');
  const [fireQualificationYn, setFireQualificationYn] = React.useState('');
  const [lifeCrerYn, setLifeCrerYn] = React.useState('');
  const [fireCrerYn, setFireCrerYn] = React.useState('');
  const [exclYn, setExclYn] = React.useState('');

  function openPopup() {
    setShowPopup(true);
  }
  async function closePopup() {
    await setLifeQualificationYn('');
    await setFireQualificationYn('');
    await setShowPopup(false);
  }

  
  function onStChange(e) {
    const { name, value } = e.target;
    
    if(name == 'lifeQualificationYn'){
      setLifeQualificationYn(value);
    } else if(name == 'fireQualificationYn'){
      setFireQualificationYn(value);
    } else if(name == 'lifeCrerYn'){
      setLifeCrerYn(value);
    } else if(name == 'fireCrerYn'){
      setFireCrerYn(value);
    } else {
      setExclYn(value);
    }
  }
  
  const handleOnClick = async (e) => {
    const { taskNo } = e.target.dataset;
    
    await setTaskNo(taskNo);
    await openPopup();
  };
  
  const handleGoToNext = async () => { 
    if(taskNo == '53' && !lifeQualificationYn){
      return Swal('생보 유자격자 확인', '필수 입니다.', 'info');
    } else if(taskNo == '54' && !fireQualificationYn){
      return Swal('손보 유자격자 확인', '필수 입니다.', 'info');
    } else if(taskNo == '52' && (!lifeQualificationYn || !fireQualificationYn)){
      return Swal('생손보 유자격자 확인', '필수 입니다.', 'info');
    }
    
    // 경력확인 팝업
    await openPopup2();
    // await dispatch(setTask(taskNo, '0', qualificationYn));
    // history.push(`/${state.corpNm}/1`);
  };
  
  // 경력확인 팝업
  function openPopup2() {
    setShowPopup2(true);
  }

  async function closePopup2() {
    await setLifeCrerYn('');
    await setFireCrerYn('');
    await setExclYn('');
    await setShowPopup2(false);
  }

  const handleGoToNext2 = async () => {
    if(taskNo == '53' && !lifeCrerYn){
      return Swal('생보 경력 확인', '필수 입니다.', 'info');
    } else if(taskNo == '54' && !fireCrerYn){
      return Swal('손보 경력 확인', '필수 입니다.', 'info');
    } else if(taskNo == '52' && (!lifeCrerYn || !fireCrerYn)){
      return Swal('생손보 경력 확인', '필수 입니다.', 'info');
    }
    
    if(fireCrerYn == '1' && !exclYn){
      return Swal('메리츠 전속 확인', '필수 입니다.', 'info');
    }

    let qualificationYn;
    let crerYn;

    if((lifeQualificationYn == '1' || fireQualificationYn == '1') && (lifeCrerYn == '1' || fireCrerYn == '1')){
      qualificationYn = '1';
      crerYn = '1';
    } else if((lifeQualificationYn == '1' || fireQualificationYn == '1') && lifeCrerYn !== '1' && fireCrerYn !== '1'){
      qualificationYn = '1';
      crerYn = '0';
    } else if((lifeCrerYn == '1' || fireCrerYn == '1') && lifeQualificationYn !== '1' && fireQualificationYn !== '1'){
      qualificationYn = '0';
      crerYn = '1';
    } else {
      qualificationYn = '0';
      crerYn = '0';
    }

    await dispatch(setTask(taskNo, '0', qualificationYn, crerYn, lifeQualificationYn, fireQualificationYn, lifeCrerYn, fireCrerYn, exclYn));
    history.push(`/${state.corpNm}/1`);
  };

  React.useEffect(() => {
    persistor.purge();

    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/corpInfo",
      param
    ).then(({ data }) => {
      if (data.status === "SUCCESS") {
        const result = data.data;
        const length = result.length;
        
        if (length > 0) {
          dispatch(
            setCorp({
              corpNo: String(result[0].CORP_NO),
              corpNm: result[0].IF_KEY,
            })
          );
        } else {
          dispatch(
            setCorp({
              corpNo: "",
              corpNm: "",
            })
          );
        }

        setIsLoading(false);
      }
    });

    return () => setTasks([]);
  }, []);

  React.useEffect(() => {
    if(state.corpNo !== "") {
      ApiHelper.request(ApiHelper.methods.post, "/cust/request/taskList", param2)
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let taskList = data.data;

          setTasks(taskList);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
    } 
  }, [state.corpNo]);

  return (
    isLoading ? (
      <div>Loading...</div>
    ) : (
      state.corpNm ?
        <>
          <TheHeader />
          <div className="c-main">
            <CContainer>
              <h1>
                <b>EasyPaper</b>
              </h1>
              <h5>
                <b>
                  <br />
                  이지페이퍼란 서면 작성하셨던 위촉서류를 전산으로 간소화하여 작성하는 프로그램입니다.<br />
                  서류 작성이 완료되면 꼭 <span className="warningText">출력 후 원본 제출</span>하셔야 합니다. (<span className="warningText">양면 및 이면지 출력 불가</span>)<br />
                  <br />
                  * 출력 후 원본 서류에 자필 서명 원수사 : 삼성생명, DB생명, 처브라이프<br />
                  <br />
                  아래에서 진행할 업무를 선택하세요.
                </b>
              </h5>
            </CContainer>

            <CCardBody>
              <CCardHeader></CCardHeader>
              {tasks.map((task) => {
                return (
                  <CRow className="mb-2 mt-2" key={task.TASK_NO}>
                    <CCol xs="12">
                      <CButton
                        color="primary"
                        variant="outline"
                        block
                        data-task-no={task.TASK_NO}
                        onClick={(e) => handleOnClick(e)}
                      >
                        {task.TASK_NM}
                      </CButton>
                    </CCol>
                  </CRow>
                );
              })}
              <CCardFooter></CCardFooter>
                <CCol>
                  <h4><b>안내사항</b></h4>
                </CCol>
                <CCol>
                  <h5>
                  신분증, 통장사본, 증명사진, 교육수료증(1년 이내 보험연수원 수료증). 시험합격증(신인), E-클린서비스 조회내역(경력, URL: <a href="http://www.e-cleanins.or.kr/">http://www.e-cleanins.or.kr/</a>), 경력증명서(경력, 직전 근무사)<br />
                    사전 준비 하셔서 본 시스템에 업로드 하여 주시기 바랍니다.
                  </h5>
                  <br />
                </CCol>
              <CCardFooter></CCardFooter>
            </CCardBody>
          </div>
          {showPopup &&
          <div className="layer-popup">
            <div className="box-popup popup-sign">
              <button
                className="popup-close"
                onClick={closePopup}
                type="button"
              >
                {' '}
              </button>
              <div className="popup-title">자격 확인</div>
              <div className="popup-contents">
                <span className="txt-label">유자격자의 경우 협회등록서류가 추가로 필요하므로 해당되는 내용을 선택해 주세요.</span>
                <div className="inline-label"></div>
                <fieldset className={`radio-fileset ${taskNo === '53' ? 'disabled-radio' : ''}`}>
                <div className="life-fire">[ 손보 ]</div>
                <div className="radio-inline">
                  <label className="component-radio type-default">
                    <input type="radio" name="fireQualificationYn" value="0"
                      onChange={(e) => onStChange(e)}
                      checked={fireQualificationYn === '0'} 
                      disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">설계사</div>
                  </label>
                  <label className="component-radio type-default">
                    <input type="radio" name="fireQualificationYn" value="1"
                    onChange={(e) => onStChange(e)}
                    checked={fireQualificationYn === '1'}
                    disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">유자격</div>
                  </label>
                </div>
                </fieldset>
                <fieldset className={`radio-fileset ${taskNo === '54' ? 'disabled-radio' : ''}`}>
                <div className="life-fire">[ 생보 ]</div>
                <div className="radio-inline">
                  <label className="component-radio type-default">
                    <input type="radio" name="lifeQualificationYn" value="0"
                      onChange={(e) => onStChange(e)}
                      checked={lifeQualificationYn === '0'}
                      disabled={taskNo === '54'} />
                    <i />
                    <div className="text-label">설계사</div>
                  </label>
                  <label className="component-radio type-default">
                    <input type="radio" name="lifeQualificationYn" value="1"
                    onChange={(e) => onStChange(e)}
                    checked={lifeQualificationYn === '1'}
                    disabled={taskNo === '54'} />
                    <i />
                    <div className="text-label">유자격</div>
                  </label>
                </div>
                </fieldset>
              </div>
              <div className="popup-footer">
                <button className="btn-footer" type="button" onClick={() => closePopup()}>
                  닫기
                </button>
                <button className="btn-footer type-solid" type="button" onClick={handleGoToNext}>
                  확인
                </button>
              </div>
            </div>
          </div>}
          {showPopup2 &&
          <div className="layer-popup">
            <div className="box-popup popup-sign">
              <button
                className="popup-close"
                onClick={closePopup2}
                type="button"
              >
                {' '}
              </button>
              <div className="popup-title">경력 확인</div>
              <div className="popup-contents">
                <span className="txt-label">경력자와 신규의 첨부서류가 다르므로 해당되는 내용을 선택해 주세요.</span>
                <div className="inline-label"></div>
                <fieldset className={`radio-fileset ${taskNo === '53' ? 'disabled-radio' : ''}`}>
                <div className="life-fire">[ 손보 ]</div>
                <div className="radio-inline">
                  <label className="component-radio type-default">
                    <input type="radio" name="fireCrerYn" value="1"
                      onChange={(e) => onStChange(e)}
                      checked={fireCrerYn === '1'}
                      disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">경력</div>
                  </label>
                  <label className="component-radio type-default">
                    <input type="radio" name="fireCrerYn" value="0"
                    onChange={(e) => onStChange(e)}
                    checked={fireCrerYn === '0'}
                    disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">신규</div>
                  </label>
                </div>
                </fieldset>
                { fireCrerYn === '1' &&
                <fieldset className={`radio-fileset ${taskNo === '53' ? 'disabled-radio' : ''}`}>
                <div className="life-fire">[ 메리츠 전속 ]</div>
                <div className="radio-inline">
                  <label className="component-radio type-default">
                    <input type="radio" name="exclYn" value="1"
                      onChange={(e) => onStChange(e)}
                      checked={exclYn === '1'}
                      disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">전속</div>
                  </label>
                  <label className="component-radio type-default">
                    <input type="radio" name="exclYn" value="0"
                    onChange={(e) => onStChange(e)}
                    checked={exclYn === '0'}
                    disabled={taskNo === '53'} />
                    <i />
                    <div className="text-label">해당없음</div>
                  </label>
                </div>
                </fieldset>
                }
                <fieldset className={`radio-fileset ${taskNo === '54' ? 'disabled-radio' : ''}`}>
                <div className="life-fire">[ 생보 ]</div>
                <div className="radio-inline">
                  <label className="component-radio type-default">
                    <input type="radio" name="lifeCrerYn" value="1"
                      onChange={(e) => onStChange(e)}
                      checked={lifeCrerYn === '1'}
                      disabled={taskNo === '54'} />
                    <i />
                    <div className="text-label">경력</div>
                  </label>
                  <label className="component-radio type-default">
                    <input type="radio" name="lifeCrerYn" value="0"
                    onChange={(e) => onStChange(e)}
                    checked={lifeCrerYn === '0'}
                    disabled={taskNo === '54'} />
                    <i />
                    <div className="text-label">신규</div>
                  </label>
                </div>
                </fieldset>
              </div>
              <div className="popup-footer">
                <button className="btn-footer" type="button" onClick={() => closePopup2()}>
                  닫기
                </button>
                <button className="btn-footer type-solid" type="button" onClick={handleGoToNext2}>
                  확인
                </button>
              </div>
            </div>
          </div>}
        </>
      : <Error />
    )
  );
};

export default MainPage;
